import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 flex justify-end"
}

import { useGetTypesQuery } from '@/entities/type/hooks';
import { Type } from '@/entities/type/types';
import {
  computed,
  PropType, inject, nextTick,
} from 'vue';

import {
  CreateDeviceData,
  Device, DeviceCreateFormProvider,
} from '@/entities/device/types';

import {
  NkHeading,
  NkButton,
  NkStack,
} from '@/core/components';

import DeviceModelFromPartField from '@/entities/device/components/form/DeviceModelFormPartField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceModelFormPart',
  props: {
  type: {
    type: Number,
    required: true,
  },
  fieldsPath: {
    type: String,
    default: '',
  },
  fields: {
    type: Object as PropType<CreateDeviceData>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const {data: types } = useGetTypesQuery();

const deviceForm: DeviceCreateFormProvider = (inject('deviceForm') as DeviceCreateFormProvider);
const selectedFieldsPath = computed(() => deviceForm.selectedFieldsPath.value);

const isVisible = computed(() => selectedFieldsPath.value === props.fieldsPath);

const getSubDeviceFieldsPath = (index: number) => [props.fieldsPath, `subDevices.${ index }`].filter(Boolean).join('.');
const getType = (typeId: Type['id']) => types.value?.find(t => t.id === typeId);

const handleDeviceDeletion = (index: number) => {
  // eslint-disable-next-line vue/no-mutating-props
  props.fields.subDevices = props.fields.subDevices.filter((o: Device, _index: number) => index !== _index);

  nextTick(() => {
    if (props.fields.subDevices.length) {
      deviceForm.setSelectedFieldsPath(getSubDeviceFieldsPath(props.fields.subDevices.length - 1))
    } else {
      deviceForm.setSelectedFieldsPath(props.fieldsPath);
    }
  })
};

return (_ctx: any,_cache: any) => {
  const _component_DeviceModelFormPart = _resolveComponent("DeviceModelFormPart", true)!

  return (props.fields)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(isVisible))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(NkHeading), {
                  class: "flex-1",
                  type: "small-bold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getType(props.type)?.name || '-'), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(NkStack), { spacing: 3 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fields.deviceValues, (deviceValue, i) => {
                    return (_openBlock(), _createBlock(DeviceModelFromPartField, {
                      key: deviceValue.reference,
                      model: deviceValue,
                      "field-path": [__props.fieldsPath, `deviceValues.${i}`].filter(Boolean).join('.')
                    }, null, 8, ["model", "field-path"]))
                  }), 128))
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (props.fields?.subDevices)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.fields.subDevices || [], (subDevice, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${subDevice.type}-${i}`
              }, [
                (getSubDeviceFieldsPath(i) === _unref(selectedFieldsPath))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(NkButton), {
                        type: "danger",
                        size: "md",
                        icon: "NkDelete",
                        onClick: _withModifiers(($event: any) => (handleDeviceDeletion(i)), ["stop","prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('device.action.device_delete')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_DeviceModelFormPart, {
                  "fields-path": getSubDeviceFieldsPath(i),
                  type: subDevice.type,
                  fields: props.fields.subDevices[i]
                }, null, 8, ["fields-path", "type", "fields"])
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})